












import { Component, Vue, Prop } from 'vue-property-decorator'

@Component
export default class UserPanel extends Vue {
  @Prop() isLoading = true
  @Prop() userContext: TwitchUserInterface | null = null
}
